module.exports = __webpack_public_path__ + "static/media/insta-3.795e87bd.png";